import PropTypes from 'prop-types';
// material
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
// idioma
import { esES } from '@mui/material/locale';
// hooks
import useLocales from '../hooks/useLocales';

// ----------------------------------------------------------------------

ThemeLocalization.propTypes = {
  children: PropTypes.node
};

export default function ThemeLocalization({ children }) {
  const defaultTheme = useTheme();
  const { currentLang } = useLocales();

  const theme = createTheme(defaultTheme, esES);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
